<progress [value]="progressValue" [max]="100" [ngClass]="color!"></progress>
